var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, } from "react";
import { Icon } from "../../icon";
import { useTheme } from "styled-components";
import { Spinner } from "../../spinner";
import { Button } from "../../button";
import { StyledNotification, Wrapper } from "./notification.styles";
export const Notification = (_a) => {
    var { text, type = "broadcast", buttonText, symbol = "arrow_right", hasSpinner = false, hasControl = true, onClick, buttonStyleType = "flatInverted", showCloseButton = false, closeButtonStyleType = "iconInverted", animation = false, spinnerDuration, positionTop = 20, className } = _a, restProps = __rest(_a, ["text", "type", "buttonText", "symbol", "hasSpinner", "hasControl", "onClick", "buttonStyleType", "showCloseButton", "closeButtonStyleType", "animation", "spinnerDuration", "positionTop", "className"]);
    const theme = useTheme();
    const [fade, setFade] = useState(false);
    const [height, setHeight] = useState(0);
    const wrapperRef = React.useRef(null);
    useEffect(() => {
        if (wrapperRef) {
            setHeight(wrapperRef.current.clientHeight);
        }
    }, []);
    function renderButton() {
        if (showCloseButton) {
            return (_jsx(Button, { onClick: (e) => {
                    if (typeof onClick === "function") {
                        onClick(e, "CLOSE");
                    }
                    setFade(true);
                }, symbol: "Close", isIcon: true, stylingType: closeButtonStyleType }));
        }
        if (buttonText && type !== "toast") {
            return (_jsx(Button, Object.assign({ onClick: (e) => {
                    if (typeof onClick === "function") {
                        onClick(e, "ACTION");
                    }
                } }, (symbol ? { symbol } : {}), { stylingType: buttonStyleType }, { children: buttonText })));
        }
        if (buttonText && hasControl) {
            return (_jsx(Button, Object.assign({ onClick: (e) => {
                    if (typeof onClick === "function") {
                        onClick(e, "ACTION");
                    }
                    setFade(true);
                }, stylingType: buttonStyleType }, { children: buttonText })));
        }
        return _jsx(_Fragment, {});
    }
    return (_jsx(Wrapper, Object.assign({ "$type": type, "$height": height, fade: fade, animation: animation, ref: wrapperRef, positionTop: positionTop, className: className }, restProps, { children: _jsxs(StyledNotification, Object.assign({ "$type": type, hasSpinner: hasSpinner, hasButton: buttonText !== undefined && hasControl }, { children: [_jsxs("div", { children: [type !== "toast" ? (_jsx(Icon, { symbol: "warning_info", width: "1.5rem", color: `${theme.colors.white}` })) : hasSpinner ? (_jsxs("span", { children: [_jsx(Spinner, { inverted: true, animationDuration: spinnerDuration }), " "] })) : (""), _jsx("div", { children: text }), " "] }), _jsx("div", { children: renderButton() })] })) })));
};
